import React, { useEffect, useState, useContext } from 'react'
import { LeagueContext } from '../../Context'
import { AutocompleteContainer } from '../../Components/Search'
import { PageContainerMain, Box } from '../../Components/Layout'
import { mapEventsByMarket } from '../../Utils'
import { Loading } from '../Loading'
import { ScheduleHeader } from '../Schedule/ScheduleHeader'
import { WeekendCard } from './components/WeekendCard'
import { EventGQL } from '../../Api'
import { ListAnimation } from '../../Components/Animations/ListAnimations'

const Tickets: React.FC = () => {
  const { events, eventsLoading } = useContext(LeagueContext)!
  const [marketEventsList, setMarketEventsList] = useState<{
    [key: string]: EventGQL[]
  }>({})

  useEffect(() => {
    if (events.length > 0) {
      const marketEventsList = mapEventsByMarket(events)
      setMarketEventsList(marketEventsList)
    }
  }, [events])

  return (
    <PageContainerMain sidePadding={0} fullScreen>
      <AutocompleteContainer />
      <ScheduleHeader showListView={false} page={'Tickets'} showHeaderItems={false} />
      {eventsLoading ? (
        <Box>
          <Loading />
        </Box>
      ) : (
        <>
          {events.length > 0 && (
            <Box vertMargins={0.25}>
              {Object.entries(marketEventsList).map(([market, events], index) => (
                <ListAnimation key={market} index={index} stagger={100}>
                  <WeekendCard key={market} events={events} />
                </ListAnimation>
              ))}
            </Box>
          )}
        </>
      )}
    </PageContainerMain>
  )
}

export default Tickets
